<template>
    <v-snackbar
        :color="color"
        location="bottom center"
        v-model="visible"
        :timeout="timeout"
    >
        {{ message }}

        <template v-slot:actions>
            <v-btn
                v-if="isGoToViewDefined"
                class="text-uppercase mx-3"
                variant="text"
                :to="{
                    name: `${payload.goToView.name}.view`,
                    params: { id: payload.goToView.id },
                }"
                @click="reInitPayload"
            >
                Open {{ payload.goToView.name }}
            </v-btn>
            <v-btn variant="elevated" @click="reInitPayload" class="mx-1">Dismiss</v-btn>
        </template>
    </v-snackbar>
</template>

<script>
import eventBus from "../eventBus";

const httpStatusCodeMap = [
    {
        status: 200,
        type: "success",
        message: "Action successful",
    },
    {
        status: 401,
        type: "error",
        message: "You don't have sufficient permissions to perform this action",
    },
    {
        status: 403,
        type: "error",
        message: "Unauthenticated",
    },
    {
        status: 404,
        type: "error",
        message: "Cannot find this item",
    },
    {
        status: 422,
        type: "error",
        message: "The data provided was invalid",
    },
    {
        status: 500,
        type: "error",
        message: `We're having internal issues, our engineers have been notified`,
    },
    {
        status: 501,
        type: "error",
        message: `We're having internal issues, our engineers have been notified`,
    },
];

const initPayload = {
    status: null,
    data: {
        message: "",
    },
    statusText: "",
    timeout: -1,
};

export default {
    data() {
        return {
            payload: {
                status: null,
                data: {
                    message: "",
                },
                statusText: "",
                color: null,
                timeout: -1,
            },
        };
    },
    computed: {
        matchingStatusCode() {
            let statusCode = httpStatusCodeMap.find(item => item.status === this.payload.status);

            if (statusCode !== undefined) {
                return statusCode;
            }

            return null;
        },
        color() {
            if (this.payload.color != null) {
                return this.payload.color;
            }

            if (this.matchingStatusCode !== null) {
                return this.matchingStatusCode.type;
            }

            return null;
        },
        timeout() {
            return this.payload.timeout ?? 6000;
        },
        visible: {
            get() {
                return this.message.length > 0;
            },
            set() {
                this.reInitPayload();
            },
        },
        message() {
            if (this.payload.data?.errors !== undefined) {
                let errorKeys = Object.keys(this.payload.data.errors);
                let firstError = this.payload.data.errors[errorKeys[0]][0];
                return firstError;
            }

            if (this.payload.data?.message?.length > 0) {
                return this.payload.data.message;
            }

            if (this.payload.statusText?.length > 0) {
                return this.payload.statusText;
            }

            if (this.payload?.data?.description?.[0]?.length > 0) {
                return this.payload.data.description[0];
            }

            return "";
        },
        isGoToViewDefined() {
            return (
                typeof payload !== "undefined" &&
                typeof payload.goToView !== "undefined"
            );
        },
    },
    methods: {
        reInitPayload() {
            this.payload = initPayload;
        },
    },
    mounted() {
        this.reInitPayload();
        this._onShowAlert = (payload) => {
            if (this.payload.status !== null) {
                this.payload = initPayload;
            }
            this.$nextTick(() => {
                this.payload = payload;
            });
        };
        eventBus.on("SHOW_ALERT", this._onShowAlert);
    },
    beforeUnmount() {
        eventBus.off("SHOW_ALERT", this._onShowAlert);
    },
};
</script>
